<template>
    <aside :class="{collapsed: collapsed}">
        <div class="toggle">
            <b-button
                v-b-tooltip.left="collapsed ? $t('Expand sidebar') : $t('Collapse sidebar')"
                class="rounded-0 align-self-start"
                variant="grey"
                @click="collapsed = !collapsed"
            >
                <fa fixed-width :icon="collapsed ? 'angle-double-left' : 'angle-double-right'"/>
            </b-button>

        <hr class="w-100">
        </div>

        <div class="content">
            <slot v-bind:collapsed="collapsed"></slot>
        </div>
    </aside>
</template>
<script>
    export default {
        name: 'Sidebar',
        data() {
            return {
                collapsed: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "resources/sass/variables";

    aside {
        border-left: 1px solid $border-color;
        background-color: #F7F7F7;
        display: flex;
        flex-direction: column;
        min-width: 200px;
        padding: .5rem;

        &.collapsed {
            min-width: auto;
        }
    }

    .toggle {
        position: sticky;
        top: $spacer;
    }

    .content {
        position: sticky;
        top: calc( #{$spacer} + 70px);
    }
</style>
